import React, {useState, useEffect, useRef} from 'react';
import TariffCard from '../components/TariffCard';
import OneImg from "../images/1.svg";
import TwoImg from "../images/2.png";
import ThreeImg from "../images/3.png";
import FourImg from "../images/4.png";
import FiveImg from "../images/5.svg";
import SixImg from "../images/6.svg";
import SevenImg from "../images/7.svg";
import EightImg from "../images/8.png";
import NineImg from "../images/9.png";
import TenImg from "../images/10.svg";
import ThirteenImg from "../images/13.webp";
import {IdTariff} from '../contexts/HomeContext';
import axios from "axios";
import {validateEmail, validatePhone} from "../utils/Validator";
import {
    URL_CONFIRM_SUBSCRITION,
    URL_CREATE_SUBSCRITION,
    URL_GET_ALL_TARIFF,
    URL_PROMO_CODE_VALIDATION
} from "../resources/ServerUrl";


const HomePage = () => {
    const viewport = document.querySelector("meta[name=viewport]");
    const [tariffId, setTariffId] = useState(null);
    const [tariffs, setTariffs] = useState([]);
    const [titleOneStyle, setTitleOneStyle] = useState({});
    const [emailStyle, setEmailStyle] = useState({});
    const [wrapperPhoneStyle, setWrapperPhoneStyle] = useState({});
    const [phoneStyle, setPhoneStyle] = useState({});
    const [discountCodeStyle, setDiscountCodeStyle] = useState({});
    const [buyStyle, setBuyStyle] = useState({});
    const [curtains1Style, setCurtains1Style] = useState({});
    const [curtains2Style, setCurtains2Style] = useState({});
    const [corniceStyle, setCorniceStyle] = useState({});
    const [confirmStyle, setConfirmStyle] = useState({display: "none"});
    const [codeStyle, setCodeStyle] = useState({display: "none"});
    const [loaderStyle, setLoaderStyle] = useState({display: "none"});
    const [titleTwoStyle, setTitleTwoStyle] = useState({display: "none"});
    const [titleThreeStyle, setTitleThreeStyle] = useState({display: "none"});
    const [titleFourStyle, setTitleFourStyle] = useState({display: "none"});
    const [subscriptionId, setSubscriptionId] = useState(0);
    const emailRef = useRef();
    const phoneRef = useRef();
    const codeRef = useRef();
    const discountCodeRef = useRef();


    const determineViewportSize = () => {
        if (window.screen.availWidth < 500) {
            viewport.setAttribute('content', 'width=410');
        } else viewport.setAttribute('content', 'width=1600');
    }
    window.onresize = function () {
        determineViewportSize();
    }

    const requestGetAllTariff = () => {
        axios.get(URL_GET_ALL_TARIFF, {}).then(response => {
            setTariffs(response.data.sort((prev, next) => prev.id - next.id));
        });
    }

    const establishScrollStartingPosition = () => {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
    }

    useEffect(() => {
        requestGetAllTariff();
        determineViewportSize();
        establishScrollStartingPosition();
        setTimeout(() => {
            openCurtains();
        }, 2000);
    }, []);


    const requestCreateSubscription = () => {
        const requestBody = {
            "email": emailRef.current.value,
            "phone": "+7" + phoneRef.current.value,
            "tariffId": tariffId,
            "discountCode": discountCodeRef.current.value
        }


        if (validateEmail(requestBody.email) && validatePhone(requestBody.phone)) {
            setLoaderStyle({});
            setBuyStyle({display: "none"});
            setEmailStyle({display: "none"});
            setWrapperPhoneStyle({display: "none"});
            setTitleOneStyle({display: "none"});
            setDiscountCodeStyle({display: "none"});
            axios.post(URL_CREATE_SUBSCRITION, requestBody, {}).then(response => {
                setLoaderStyle({display: "none"});
                if (response.data.errorCode === 0) {
                    setSubscriptionId(response.data.subscriptionId);
                    setTitleTwoStyle({});
                    setConfirmStyle({});
                    setCodeStyle({});
                    setTimeout(() => {
                        setTitleTwoStyle({display: "none"});
                        setConfirmStyle({display: "none"});
                        setCodeStyle({display: "none"});
                        setTitleOneStyle({});
                        setEmailStyle({});
                        setWrapperPhoneStyle({});
                        setBuyStyle({});
                        setDiscountCodeStyle({});
                    }, 300000);
                }
                if (response.data.errorCode === 3 ||
                    response.data.errorCode === 10 ||
                    response.data.errorCode === 5) {
                    setTitleThreeStyle({});
                    setBuyStyle({display: "none"});
                    setEmailStyle({display: "none"});
                    setWrapperPhoneStyle({display: "none"});
                    setTitleOneStyle({display: "none"});
                    setCodeStyle({display: "none"});
                    setDiscountCodeStyle({display: "none"});
                    setConfirmStyle({display: "none"});
                    setTitleTwoStyle({display: "none"});
                    setLoaderStyle({display: "none"});
                    setTimeout(() => {
                        setTitleThreeStyle({display: "none"});
                        setEmailStyle({});
                        setWrapperPhoneStyle({});
                        setTitleOneStyle({});
                        setDiscountCodeStyle({});
                        setBuyStyle({});
                    }, 5000);
                }
            });
        } else {
            setEmailStyle({color: "red", border: "1px solid red"});
            setWrapperPhoneStyle({color: "red", border: "1px solid red"});
            setPhoneStyle({color: "red"});
            setTimeout(() => {
                setEmailStyle({});
                setWrapperPhoneStyle({});
                setPhoneStyle({});
            }, 2000);
        }
    }

    const requestConfirmEmail = () => {
        const requestBody = {
            "subscriptionId": subscriptionId,
            "code": codeRef.current.value
        }
        axios.post(URL_CONFIRM_SUBSCRITION, requestBody, {}).then(response => {
            if (response.status === 200) {
                 setConfirmStyle({display: "none"});
                 setCodeStyle({display: "none"});
                 setTitleTwoStyle({display: "none"});
                 setTitleFourStyle({});

            }
            if (response.data.errorCode === 8 || response.data.errorCode === 7 || response.data.errorCode === 14) {
                setCodeStyle({color: "red", border: "1px solid red"});
                setTimeout(() => {
                    setCodeStyle({});
                }, 2000);
            }
        })
    }


    let i = 0;
    let x = 0.0;
    const openCurtains = () => {
        x += 0.3;
        i++;
        if (i <= 300) {
            setTimeout(() => {
                openCurtains();
                setCurtains1Style({marginLeft: "-" + x + "%"})
                setCurtains2Style({marginRight: "-" + x + "%"});
            }, 0);
        }
        if (i === 300) setCorniceStyle({display: "none"});
    }


    const requestPromoCodeValidation = () => {
        axios.get(URL_PROMO_CODE_VALIDATION+discountCodeRef.current.value).then(response =>{
            if (response.data === true) setDiscountCodeStyle({color:"limegreen"});
            else setDiscountCodeStyle({});
        });

    }


    return (
        <IdTariff.Provider value={{tariffId, setTariffId}}>
            <div id='home_page'>
                <div style={corniceStyle} className="cornice">
                    <div style={curtains1Style} className="curtains1"></div>
                    <div style={curtains2Style} className="curtains2"></div>
                </div>

                <div className='container'>
                    <header className='header'>
                        <div className='internal_arbita'></div>
                        <div className='external_arbita'>
                            <img alt='#' className='thirteen_img' src={ThirteenImg}/>
                        </div>
                        <div className='logo'><span>unblock</span></div>
                        <h1>Свободный доступ <br/>
                            в интернет<span> БЕЗ ГРАНИЦ</span></h1>
                        <p>
                            C Unblock легко создать собственный<br/>
                            vpn-сервер, чтобы пользоваться<br/>
                            Интернетом без цензуры
                        </p>
                        <img alt='#' className="one_img" src={OneImg}/>

                    </header>
                    <div className='tariffs'>
                        <h2>Тарифы</h2>
                        <div className='tariff_card_container'>
                            {
                                tariffs.map(tariff => {
                                    return <TariffCard key={tariff.id} tariff={tariff}/>
                                })
                            }
                        </div>
                    </div>
                    <div className='manual'>
                        <h2>Инструкция</h2>
                        <div className='parts'>
                            <div className='part_one'>
                                <div className='phantom'>
                                    <img alt="#" src={TwoImg}/>
                                    <div className='phantom_speaker'></div>
                                    <div className='phantom_camera'></div>
                                </div>
                                <div className='number'>1</div>
                                <div className='description'><span>Оплатите выбранный тариф</span><br/>Принимаем только
                                    переводом на СБЕР
                                </div>
                            </div>
                            <div className='part_two'>
                                <div className='phantom'>
                                    <img alt="#" src={ThreeImg}/>
                                    <div className='phantom_speaker'></div>
                                    <div className='phantom_camera'></div>
                                </div>
                                <div className='number'>2</div>
                                <div className='description'><span>Скопируйте ключ из почты</span><br/>Ключ придёт на
                                    вашу почту, его нужно скопировать
                                </div>
                            </div>
                            <div className='part_three'>
                                <div className='phantom'>
                                    <img alt='#' src={FourImg}/>
                                    <div className='phantom_speaker'></div>
                                    <div className='phantom_camera'></div>
                                </div>
                                <div className='number'>3</div>
                                <div className='description'><span>Скачайте приложение Outline</span><br/>Установите
                                    приложение на IOS, Android, Windows или MacOS
                                    и вставьте ключ. Готово!
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='form_registration'>
                        <h2 style={titleOneStyle} className='title_one'>Подключитесь прямо сейчас</h2>
                        <h2 style={titleTwoStyle} className='title_two'>ВВЕДИТЕ КОД КОТОРЫЙ ПРИШЁЛ НА ПОЧТУ</h2>
                        <h2 style={titleThreeStyle} className='title_three'>Временно нет свободных серверов</h2>
                        <h2 style={titleFourStyle} className='title_fore'>На вашу почту высланы реквизиты для оплаты</h2>
                        <input style={emailStyle} ref={emailRef} className='email' type='email' placeholder='EMAIL'/>
                        <div style={wrapperPhoneStyle} className='wrapper_phone'><span>+7</span><input
                            style={phoneStyle} maxLength='10' ref={phoneRef}
                            className='phone' type='tel'
                            placeholder='( .  ) . -  -'/></div>
                        <input onChange={requestPromoCodeValidation} style={discountCodeStyle} ref={discountCodeRef}
                               className='discount_code' type='text' placeholder='PROMOCODE ИЛИ EMAIL'/>
                        <input style={codeStyle} ref={codeRef} className='code' type='text' placeholder='КОД'/>
                        <button style={buyStyle} onClick={requestCreateSubscription} className='buy'>Купить</button>
                        <button style={confirmStyle} onClick={requestConfirmEmail} className='confirm'>Подтвердить
                        </button>
                        <div className="loader_container">
                            <div style={loaderStyle} className="loader"></div>
                        </div>
                    </div>
                    <div className='basement'>
                        <h2>Скачать приложение Outline для настольных<br/> и мобильных устройств</h2>
                        <p>Загрузите приложение Outline ниже по ссылке и подключитесь
                            с помощью уникального ключа доступа. Приложение доступно для настольных
                            и мобильных устройств, поэтому вы можете получить защищенный доступ к интернету где
                            бы вы ни находились.</p>
                        <div className="link_container">
                        <a href="https://apps.apple.com/ru/app/outline-app/id1356177741" className='ios_link'>
                            <img alt='#' src={FiveImg}/>
                            <p>IOS</p>
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=org.outline.android.client&hl=en&gl=US"
                           className='android_link'>
                            <img alt='#' src={SixImg}/>
                            <p>Android</p>
                        </a>
                        <a href="https://s3.amazonaws.com/outline-releases/client/windows/stable/Outline-Client.exe"
                           className='windows_link'>
                            <img alt='#' src={SevenImg}/>
                            <p>Windows</p>
                        </a>
                        <a href="https://apps.apple.com/ru/app/outline-secure-internet-access/id1356178125?mt=12"
                           className='macOS_link'>
                            <img alt='#' src={FiveImg}/>
                            <p>macOS</p>
                        </a>
                        <a className='linux_link'>
                            <img alt='#' src={EightImg}/>
                            <p>Linux</p>
                        </a>
                        <a className='oc_chrome_link'>
                            <img alt='#' src={NineImg}/>
                            <p>OC Chrome</p>
                        </a>
                        </div>
                        <img alt='#' className="ten_img" src={TenImg}/>
                        <div className='foundation'>
                            <a href="https://t.me/annabrandybuck" className='website_design'>Дизайн сайта</a>
                        </div>
                    </div>
                </div>
            </div>
        </IdTariff.Provider>
    );
};

export default HomePage;